import { Dictionary } from "@insite/client-framework/Common/Types";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import React, { useEffect, useState } from "react";
import { Transition } from "react-transition-group";
import { css, ThemeProps, withTheme } from "styled-components";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import { connect, useDispatch } from "react-redux";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ScrollToTop, { ScrollToTopStyles } from "@NA/Components/ScrollToTop";
import Hidden from "@insite/mobius/Hidden";
import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";

type Props = PageProps & HasShellContext & ThemeProps<BaseTheme> & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: CustomApplicationState) => ({
    isAuthenticated: state.context.session!.isAuthenticated,
    toggleDrawer: state.ADIGlobalData.loginDrawerStore.loginDrawer,
});

export interface ADIProductDetailsStickyCartStyles {
    page?: MobiusPageProps;
    container?: GridContainerProps;
    leftColumnGridItemStyle?: GridItemProps;
    centerColumnGridItemStyle?: GridItemProps;
    descriptionGridItemStyle?: GridItemProps;
    authenticatedDescriptionGridItemStyle?: GridItemProps;
    priceGridItemStyle?: GridItemProps;
    rightColumnGridItemStyle?: GridItemProps;
    pdpTapStickyHeaderGridView?: GridItemProps;
    scrollTopStyles?: ScrollToTopStyles;
    scrollWrapper?: InjectableCss;
}

export const adiProductDetailsStickyCartStyles: ADIProductDetailsStickyCartStyles = {
    page: {
        padding: 0,
        fullWidth: [true, true, true, true, true],
        css: css`
            position: fixed;
            top: 0;
            left: 50%;
            z-index: 999;
            opacity: 0;
            transform: translateY(-100%) translateX(-50%);
            padding: 0 0 5px 0;
            border: none;
            box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.25);
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            position: fixed;
                            padding: 0px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    container: {
        gap: 20,
        css: css`
            padding: 18px;
            width: 100%;
            max-width: 100% !important;
            margin: 0 auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 10px 15px 10px !important;
                        `,
                        css`
                            padding: 10px 15px 10px !important;
                        `,
                        null,
                        css`
                            padding: 5px 10px 0px;
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    leftColumnGridItemStyle: {
        width: [0, 0, 1, 1, 1],
    },
    centerColumnGridItemStyle: {
        width: [8, 8, 5, 7, 8],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            flex-basis: 60.666667%;
                            max-width: 60.666667%;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    descriptionGridItemStyle: {
        width: [12, 12, 12, 8, 8],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        padding-bottom: 35px;
                    `,
                    null,
                ])}
        `,
    },
    authenticatedDescriptionGridItemStyle: {
        width: [12, 12, 12, 12, 8],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            padding-bottom: 0px;
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    priceGridItemStyle: {
        width: [12, 12, 12, 12, 4],
        css: css`
            align-items: center;
            line-height: 32px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-top: 5px;
                    `,
                    css`
                        padding-top: 5px;
                    `,
                    null,
                    null,
                    css`
                        padding: 5px 5px 15px 5px;
                    `,
                ])}
        `,
    },
    rightColumnGridItemStyle: {
        width: [4, 4, 6, 4, 3],
        css: css`
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            flex-basis: 39.333333%;
                            max-width: 39.333333%;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    pdpTapStickyHeaderGridView: {
        css: css`
            padding-top: 0px;
            padding-bottom: 0px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            display: none;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                    
                )}
        `,
    },
    scrollWrapper: {
        css: css`
            position: relative;
            left: auto;
            width: 100%;
        `
    },
    scrollTopStyles: {
        container: {
            css: css`
                position: absolute;
                cursor: pointer;
                bottom: -50px;
                right: 0;
                z-index: 200;
                svg {
                    transform: scale(0.71);
                }
            `,
        },
    },
};

const styles = adiProductDetailsStickyCartStyles;

const transitionStyles: Dictionary<{ opacity: number; transform: string }> = {
    entering: { opacity: 1, transform: "translateY(0px) translateX(-50%)" },
    entered: { opacity: 1, transform: "translateY(0px) translateX(-50%)" },
    exiting: { opacity: 1, transform: "translateY(0px) translateX(-50%)" },
    exited: { opacity: 0, transform: "translateY(-100%) translateX(-50%)" },
};

const ADIProductDetailsStickyCart = (props: Props) => {
    const { isCurrentPage, isInShell } = props.shellContext;
    const isShell = isCurrentPage && isInShell;
    const [isShow, setIsShow] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!props.toggleDrawer) {
            setIsShow(false);
        }
    }, [props]);

    useEffect(() => {
        function eventHandler() {
            const scrollPos: any = Math.round(window.scrollY);

            if (scrollPos > 230) {
                setIsShow(true);
            } else if (isShow && scrollPos < 230) {
                setIsShow(false);
            }            
            dispatch({
                type: "Custom/PdpSticky",
                result: isShow,
            });
        }
        window.addEventListener("scroll", eventHandler, { passive: true });

        return () => {
            window.removeEventListener("scroll", eventHandler);
        };
    }, [230, isShow]);

    useEffect(() => {
        setIsShow(Boolean(isShell));
    }, [isShell]);

    if (props.toggleDrawer) {
        return null;
    }

    return (
        <Transition in={isShow} timeout={0}>
            {state => (
                <Page
                    {...styles.page}
                    as="header"
                    style={{
                        background: ADIColors.white,
                        pointerEvents: isShow ? "auto" : "none",
                        ...transitionStyles[state],
                    }}
                >
                    <GridContainer {...styles.container}>
                        <GridItem {...styles.leftColumnGridItemStyle}>
                            <Zone contentId={props.id} zoneName="imageZone" />
                        </GridItem>
                        <GridItem {...styles.centerColumnGridItemStyle}>
                            <GridContainer>
                                <GridItem
                                    {...(!props.isAuthenticated
                                        ? styles.descriptionGridItemStyle
                                        : styles.authenticatedDescriptionGridItemStyle)}
                                >
                                    <Zone contentId={props.id} zoneName="descriptionZone" />
                                </GridItem>
                                <GridItem {...styles.priceGridItemStyle}>
                                    <Zone contentId={props.id} zoneName="PriceZone" />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                        <GridItem {...styles.rightColumnGridItemStyle}>
                            <Zone contentId={props.id} zoneName="addToCartZone" />
                        </GridItem>
                        <GridItem {...styles.pdpTapStickyHeaderGridView}>
                            <Zone contentId={props.id} zoneName="pdpTabsStickyHeader" />
                        </GridItem>
                        <StyledWrapper {...styles.scrollWrapper}>
                            <Hidden below="lg">
                                <ScrollToTop extendedStyles={styles.scrollTopStyles} />
                            </Hidden>
                        </StyledWrapper>
                    </GridContainer>
                </Page>
            )}
        </Transition>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withTheme(withIsInShell(ADIProductDetailsStickyCart))),  
    definition: {
        group: "Common",
        displayName: "ADI Product Details Sticky Cart",
    },
};

export default widgetModule;
